export default "__VITE_ASSET__35b52d68__"